var map = {
	"./11dsup.svg": 298,
	"./2locaweb2-email.svg": 299,
	"./agencia-digital-header.svg": 300,
	"./amazon-horizontal.svg": 301,
	"./amazon-negative.svg": 302,
	"./amazon.svg": 303,
	"./amazonses-horizontal.svg": 304,
	"./amazonses-negative.svg": 305,
	"./amazonses.svg": 306,
	"./amex.svg": 307,
	"./angular-negative.svg": 308,
	"./angular.svg": 309,
	"./astro.svg": 310,
	"./atena-solutions-horizontal.svg": 311,
	"./atena-solutions-negative.svg": 312,
	"./atena-solutions.svg": 313,
	"./autorestart-negative.svg": 314,
	"./autorestart.svg": 315,
	"./autoupdate-negative.svg": 316,
	"./autoupdate.svg": 317,
	"./badge_app.svg": 142,
	"./badge_app_flare.svg": 140,
	"./badge_domain.svg": 143,
	"./badge_domain_flare.svg": 318,
	"./badge_hour.svg": 144,
	"./badge_hour_flare.svg": 319,
	"./badge_mig.svg": 145,
	"./badge_mig_flare.svg": 141,
	"./band.svg": 320,
	"./bell.svg": 321,
	"./bell_negative.svg": 322,
	"./blocked_users.svg": 146,
	"./bra.svg": 138,
	"./brasil.svg": 323,
	"./bun.svg": 324,
	"./c_cloudez.svg": 325,
	"./c_negativo.svg": 326,
	"./cakephp-negative.svg": 327,
	"./cakephp.svg": 328,
	"./cdn.svg": 329,
	"./centralserver-horizontal.svg": 330,
	"./centralserver.svg": 331,
	"./check.svg": 332,
	"./churn-sad.svg": 333,
	"./city-hall-elearning-negative.svg": 334,
	"./city-hall-elearning.svg": 335,
	"./city-hall-email-negative.svg": 336,
	"./city-hall-email.svg": 337,
	"./city-hall-forum-negative.svg": 338,
	"./city-hall-forum.svg": 339,
	"./city-hall-mailmarketing-negative.svg": 340,
	"./city-hall-mailmarketing.svg": 341,
	"./city-hall-official-journal-negative.svg": 342,
	"./city-hall-official-journal.svg": 343,
	"./city-hall-photo-gallery-negative.svg": 344,
	"./city-hall-photo-gallery.svg": 345,
	"./city-hall-survey-negative.svg": 346,
	"./city-hall-survey.svg": 347,
	"./city-hall-website-negative.svg": 348,
	"./city-hall-website.svg": 349,
	"./claude.svg": 350,
	"./client-dislike.svg": 351,
	"./client-like.svg": 352,
	"./cloud_blocked.svg": 353,
	"./cloud_cloudez.svg": 54,
	"./cloud_dedicado.svg": 147,
	"./cloud_deleted.svg": 354,
	"./cloud_off.svg": 355,
	"./cloudez-footer.svg": 356,
	"./cloudez.svg": 357,
	"./cloudez_footer.svg": 358,
	"./cloudezsmtp-negative.svg": 359,
	"./cloudezsmtp.svg": 360,
	"./company-altmenu.svg": 361,
	"./company-customers.svg": 362,
	"./company-dashboard.svg": 363,
	"./company-invoices.svg": 364,
	"./company-menu.svg": 365,
	"./company-plantypes.svg": 366,
	"./company-revenue.svg": 367,
	"./compline-logo.svg": 368,
	"./configr-custom-horizontal.svg": 369,
	"./configr-custom-negative.svg": 370,
	"./configr-custom.svg": 371,
	"./configr-header-logo.svg": 372,
	"./configr-horizontal.svg": 373,
	"./configr-login.svg": 374,
	"./configr-mail-negative.svg": 375,
	"./configr-mail.svg": 376,
	"./configr-negative.svg": 377,
	"./configr-positivo.svg": 378,
	"./configr-radio.svg": 379,
	"./configr.svg": 380,
	"./configr_negativo.svg": 381,
	"./container_docker.svg": 382,
	"./convertise-horizontal-negative.svg": 383,
	"./convertise-horizontal.svg": 384,
	"./convertise-negative.svg": 385,
	"./convertise.svg": 386,
	"./cotidiano-horizontal.svg": 387,
	"./cotidiano-negative.svg": 388,
	"./cotidiano.svg": 389,
	"./csc-horizontal.svg": 390,
	"./csc-negative.svg": 391,
	"./csc-radio.svg": 392,
	"./csc.svg": 393,
	"./custom-negative.svg": 394,
	"./custom.svg": 395,
	"./danger.svg": 135,
	"./debug-modal.svg": 396,
	"./delete.svg": 397,
	"./digitalocean-horizontal.svg": 398,
	"./digitalocean-negative.svg": 399,
	"./digitalocean.svg": 400,
	"./diners.svg": 401,
	"./discover.svg": 402,
	"./django-negative.svg": 403,
	"./django.svg": 404,
	"./django2.svg": 405,
	"./dm9.svg": 406,
	"./docker-negative.svg": 407,
	"./docker.svg": 408,
	"./domain-active.svg": 409,
	"./domain-deactivated.svg": 410,
	"./domo-poll.svg": 411,
	"./dotnet.svg": 412,
	"./drupal-negative.svg": 413,
	"./drupal.svg": 414,
	"./e-sus-negative.svg": 415,
	"./e-sus.svg": 416,
	"./ecommercebeleza.svg": 417,
	"./elo.svg": 418,
	"./empty-helper.svg": 148,
	"./empty.svg": 149,
	"./enotas.svg": 419,
	"./exclamation-message.svg": 103,
	"./exclamation.svg": 102,
	"./existingEmail.svg": 420,
	"./express.svg": 421,
	"./fa-solid_server.svg": 86,
	"./fastapi.svg": 422,
	"./firewall-negative.svg": 423,
	"./firewall.svg": 424,
	"./flask.svg": 425,
	"./free3.svg": 426,
	"./free3flare.svg": 427,
	"./free5.svg": 428,
	"./free5flare.svg": 429,
	"./free7.svg": 430,
	"./free7flare.svg": 431,
	"./ftp-hover.svg": 432,
	"./ftp.svg": 433,
	"./ghost-negative.svg": 434,
	"./ghost.svg": 435,
	"./golang.svg": 436,
	"./google-cloud-radio.svg": 437,
	"./google-cloud.svg": 438,
	"./google-horizontal.svg": 439,
	"./google-logo.svg": 440,
	"./google-pagespeed.svg": 150,
	"./grupoabc.svg": 441,
	"./grupodpg.svg": 442,
	"./grupodpg118.svg": 443,
	"./grupodpg119.svg": 444,
	"./grupodpg120.svg": 445,
	"./grupodpg121.svg": 446,
	"./grupodpg122.svg": 447,
	"./grupodpg123.svg": 448,
	"./grupodpg124.svg": 449,
	"./grupodpg125.svg": 450,
	"./grupodpg126.svg": 451,
	"./gsuite-negative.svg": 452,
	"./gsuite.svg": 453,
	"./hostinger-horizontal.svg": 454,
	"./hostnet-horizontal.svg": 455,
	"./hostnet.svg": 456,
	"./html-negative.svg": 457,
	"./html.svg": 458,
	"./https-lock.svg": 459,
	"./imedicina-negative.svg": 460,
	"./imedicina.svg": 461,
	"./ion_earth.svg": 151,
	"./javascript.svg": 462,
	"./jcb.svg": 463,
	"./jenkins-negative.svg": 464,
	"./jenkins.svg": 465,
	"./joomla-negative.svg": 466,
	"./joomla.svg": 467,
	"./kinghost-horizontal.svg": 468,
	"./kinghost.svg": 469,
	"./laravel-negative.svg": 470,
	"./laravel.svg": 471,
	"./late_payment.svg": 152,
	"./life-ring.svg": 472,
	"./life-ring_negative.svg": 473,
	"./linode-horizontal.svg": 474,
	"./linode-negative.svg": 475,
	"./linode.svg": 476,
	"./locaweb-horizontal.svg": 477,
	"./locaweb.svg": 478,
	"./logo_cloudez.svg": 137,
	"./lojamidhaz.svg": 479,
	"./maestro.svg": 480,
	"./magento-negative.svg": 481,
	"./magento.svg": 482,
	"./magento2-negative.svg": 483,
	"./magento2.svg": 484,
	"./mail-generic-negative.svg": 485,
	"./mail-generic.svg": 486,
	"./mailchannels.svg": 487,
	"./mailgateway.svg": 488,
	"./mailgun-negative.svg": 489,
	"./mailgun.svg": 490,
	"./mandrill-negative.svg": 491,
	"./mandrill.svg": 492,
	"./mastercard.svg": 493,
	"./mautic-negative.svg": 494,
	"./mautic.svg": 495,
	"./mautic4.svg": 496,
	"./mautic6.svg": 497,
	"./mediawiki-negative.svg": 498,
	"./mediawiki.svg": 499,
	"./memcached-negative.svg": 500,
	"./memcached.svg": 501,
	"./metabase-negative.svg": 502,
	"./metabase.svg": 503,
	"./microsoft-azure-horizontal.svg": 504,
	"./microsoft-azure-negative.svg": 505,
	"./microsoft-azure.svg": 506,
	"./microweber.svg": 507,
	"./mid.svg": 508,
	"./mig_assist.svg": 153,
	"./mig_email.svg": 154,
	"./mig_site.svg": 155,
	"./migsite2.svg": 104,
	"./mongodb-negative.svg": 509,
	"./mongodb.svg": 510,
	"./moodle-negative.svg": 511,
	"./moodle.svg": 512,
	"./mosh-negative.svg": 513,
	"./mosh.svg": 514,
	"./mysql-backup-negative.svg": 515,
	"./mysql-backup.svg": 516,
	"./mysql-negative.svg": 517,
	"./mysql-small.svg": 518,
	"./mysql.svg": 519,
	"./n8n.svg": 520,
	"./n8n_docker.svg": 521,
	"./nestjs.svg": 522,
	"./newWebmailCloud.svg": 523,
	"./newrelic-negative.svg": 524,
	"./newrelic.svg": 525,
	"./nextcloud.svg": 526,
	"./nextjs.svg": 527,
	"./nmig_assist.svg": 156,
	"./nmig_email.svg": 157,
	"./nmig_site.svg": 158,
	"./nodejs-negative.svg": 528,
	"./nodejs.svg": 529,
	"./nuvem.svg": 530,
	"./nuxtjs.svg": 531,
	"./odoo-negative.svg": 532,
	"./odoo.svg": 533,
	"./oedusantana_edupress.svg": 534,
	"./oedusantana_kitlancamento.svg": 535,
	"./oedusantana_siteconversao.svg": 536,
	"./office365-negative.svg": 537,
	"./office365.svg": 538,
	"./offline.svg": 539,
	"./onboard_check_gray.svg": 540,
	"./onboard_check_green.svg": 541,
	"./onrise.svg": 542,
	"./opencart-negative.svg": 543,
	"./opencart.svg": 544,
	"./openssh-negative.svg": 545,
	"./openssh.svg": 546,
	"./opensupports.svg": 547,
	"./oracle-negative.svg": 548,
	"./otherExistingEmail.svg": 159,
	"./overdue_invoice.svg": 549,
	"./owncloud.svg": 550,
	"./payment_done.svg": 160,
	"./pending_payment.svg": 161,
	"./php-negative.svg": 551,
	"./php.svg": 552,
	"./php7-negative.svg": 553,
	"./php7.svg": 554,
	"./phpmyadmin-icon.svg": 555,
	"./phpmyadmin-negative.svg": 556,
	"./phpmyadmin.svg": 557,
	"./phppgadmin-icon.svg": 558,
	"./phppgadmin-negative.svg": 559,
	"./phppgadmin.svg": 560,
	"./pix-negative.svg": 162,
	"./pix.svg": 163,
	"./postgresql-backup-negative.svg": 561,
	"./postgresql-backup.svg": 562,
	"./postgresql-negative.svg": 563,
	"./postgresql-small.svg": 564,
	"./postgresql.svg": 565,
	"./postmark-negative.svg": 566,
	"./postmark.svg": 567,
	"./pref-completo.svg": 568,
	"./pref-positivo.svg": 569,
	"./prestashop-negative.svg": 570,
	"./prestashop.svg": 571,
	"./python.svg": 572,
	"./rails-negative.svg": 573,
	"./rails.svg": 574,
	"./rdstation-negative.svg": 575,
	"./rdstation-sendgrid-negative.svg": 576,
	"./rdstation-sendgrid.svg": 577,
	"./rdstation-website-negative.svg": 578,
	"./rdstation-website.svg": 579,
	"./rdstation.svg": 580,
	"./react-negative.svg": 581,
	"./react.svg": 582,
	"./redis-negative.svg": 583,
	"./redis.svg": 584,
	"./referral-checkout.svg": 585,
	"./referral-ilustration.svg": 586,
	"./rocket.svg": 587,
	"./saelos-negative.svg": 588,
	"./saelos.svg": 589,
	"./santa-cap-left.svg": 590,
	"./santa-cap-right.svg": 591,
	"./sendgrid-negative.svg": 592,
	"./sendgrid.svg": 593,
	"./sendy-negative.svg": 594,
	"./sendy.svg": 595,
	"./share-modal.svg": 596,
	"./shellhub.svg": 597,
	"./smtp-hover.svg": 598,
	"./smtp.svg": 599,
	"./smtp2go-negative.svg": 600,
	"./smtp2go.svg": 601,
	"./softlayer-horizontal.svg": 602,
	"./softlayer-negative.svg": 603,
	"./softlayer.svg": 604,
	"./spam-modal.svg": 605,
	"./spam.svg": 606,
	"./sugarcrm-negative.svg": 607,
	"./sugarcrm.svg": 608,
	"./support.svg": 609,
	"./svelte.svg": 610,
	"./symfony-negative.svg": 611,
	"./symfony.svg": 612,
	"./ticketinfo.svg": 164,
	"./typescript.svg": 613,
	"./under-horizontal.svg": 614,
	"./under.svg": 615,
	"./unlink.svg": 209,
	"./uolhos.svg": 616,
	"./uolhost-horizontal.svg": 617,
	"./uolhost.svg": 618,
	"./upsites_ecommerce.svg": 619,
	"./upsites_website.svg": 620,
	"./userdir-negative.svg": 621,
	"./userdir.svg": 622,
	"./vaasstarterbronze.svg": 623,
	"./vaasstarterouro.svg": 624,
	"./vaasstarterprata.svg": 625,
	"./vert-horizontal.svg": 626,
	"./vert-negative.svg": 627,
	"./vert.svg": 628,
	"./visa.svg": 629,
	"./vite.svg": 630,
	"./vue.svg": 631,
	"./vultr-horizontal.svg": 632,
	"./vultr.svg": 633,
	"./website_shared.svg": 165,
	"./werise-horizontal-negative.svg": 634,
	"./werise-horizontal.svg": 635,
	"./woocommerce-negative.svg": 636,
	"./woocommerce.svg": 637,
	"./wordpress-negative.svg": 638,
	"./wordpress.svg": 166,
	"./wordprez-negative.svg": 639,
	"./wordprez.svg": 640,
	"./zoho-negative.svg": 641,
	"./zoho.svg": 642
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 133;